// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._syaz1rpy{color:var(--ds-text-subtlest,#6b6e76)}", ""]);
// Exports
module.exports = exports;
